/** Layouts */
import BaseLayout from '@/views/rh/entretien/checklist/layouts/BaseLayout';
import EditLayout from '@/views/rh/entretien/checklist/layouts/EditLayout';
import ShowLayout from '@/views/rh/entretien/checklist/layouts/ShowLayout';

/** Pages */
import Checklist from '@/views/rh/entretien/checklist/pages/Checklist';
import ChecklistCreate from '@/views/rh/entretien/checklist/pages/ChecklistCreate';
import ChecklistEdit from '@/views/rh/entretien/checklist/pages/ChecklistEdit';
import ChecklistShow from '@/views/rh/entretien/checklist/pages/ChecklistShow';

/** Pages */
import Question from '@/views/rh/entretien/checklist_question/pages/Question';
import QuestionCreate from '@/views/rh/entretien/checklist_question/pages/QuestionCreate';
import QuestionEdit from '@/views/rh/entretien/checklist_question/pages/QuestionEdit';
import QuestionShow from '@/views/rh/entretien/checklist_question/pages/QuestionShow';
import QuestionOrdre from '@/views/rh/entretien/checklist_question/pages/QuestionOrdre';

export default [
  {
    path: '/rh/entretien/checklist',
    component: BaseLayout,
    children: [
      {
        path: '',
        component: Checklist,
        name: 'rh_entretien_checklist',
        meta: {
          auth: true,
          module: 'rh',
          permission: 'access setting',
        },
      },
      {
        path: 'create/:filter?/:id?',
        component: ChecklistCreate,
        name: 'rh_entretien_checklist-create',
        meta: {
          auth: true,
          module: 'rh',
          permission: 'access setting',
        },
      },
      {
        path: 'edit/:id',
        component: EditLayout,
        children: [
          {
            path: '',
            component: ChecklistEdit,
            name: 'rh_entretien_checklist-edit',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'question',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: Question,
                name: 'rh_entretien_checklist_edit_question',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'create/:type',
                component: QuestionCreate,
                name: 'rh_entretien_checklist_edit_question-create',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'edit/:questionUuid/:type',
                component: QuestionEdit,
                name: 'rh_entretien_checklist_edit_question-edit',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'show/:questionUuid/:type',
                component: QuestionShow,
                name: 'rh_entretien_checklist_edit_question-show',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'ordre',
                component: QuestionOrdre,
                name: 'rh_entretien_checklist_edit_question-ordre',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'show/:id',
        component: ShowLayout,
        children: [
          {
            path: '',
            component: ChecklistShow,
            name: 'rh_entretien_checklist-show',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'question',
            component: BaseLayout,
            children: [
              {
                path: '',
                component: Question,
                name: 'rh_entretien_checklist_show_question',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'create/:type',
                component: QuestionCreate,
                name: 'rh_entretien_checklist_show_question-create',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'edit/:questionUuid/:type',
                component: QuestionEdit,
                name: 'rh_entretien_checklist_show_question-edit',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'show/:questionUuid/:type',
                component: QuestionShow,
                name: 'rh_entretien_checklist_show_question-show',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
              {
                path: 'ordre',
                component: QuestionOrdre,
                name: 'rh_entretien_checklist_show_question-ordre',
                meta: {
                  auth: true,
                  module: 'rh',
                  permission: 'access setting',
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
